import { render, staticRenderFns } from "./PostContentCreation.vue?vue&type=template&id=a5ad485c"
import script from "./PostContentCreation.vue?vue&type=script&lang=js"
export * from "./PostContentCreation.vue?vue&type=script&lang=js"
import style0 from "./PostContentCreation.vue?vue&type=style&index=0&id=a5ad485c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports